import { render, staticRenderFns } from "./TeamInfo.vue?vue&type=template&id=6fb0175e&scoped=true&"
import script from "./TeamInfo.vue?vue&type=script&lang=js&"
export * from "./TeamInfo.vue?vue&type=script&lang=js&"
import style0 from "./TeamInfo.vue?vue&type=style&index=0&id=6fb0175e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb0175e",
  null
  
)

export default component.exports